import React from 'react';
import { Box, Typography, Paper, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqs = [
    {
        question: 'నేను పోగొట్టుకున్న లేదా దొరికిన వస్తువును ఎలా పోస్ట్ చేయాలి?',
        answer: 'ఒక వస్తువును పోస్ట్ చేయడానికి మీరు తప్పనిసరిగా లాగిన్ అయి ఉండాలి. హోమ్ పేజీ నుండి, "Post Found Item" లేదా "Report Lost Item" పై క్లిక్ చేసి, అవసరమైన వివరాలను నింపండి. మీరు ఎంత ఎక్కువ వివరాలు ఇస్తే, సరైన మ్యాచ్ దొరికే అవకాశాలు అంత ఎక్కువగా ఉంటాయి.'
    },
    {
        question: 'నా సంప్రదింపు వివరాలను పంచుకోవడం సురక్షితమేనా?',
        answer: 'మేము కమ్యూనికేట్ చేయడానికి మా ఇన్-యాప్ మెసేజింగ్ ఫీచర్‌ను ఉపయోగించమని సిఫార్సు చేస్తున్నాము. ఈ విధంగా, మీరు సురక్షితమని భావించే వరకు మీ వ్యక్తిగత ఫోన్ నంబర్ లేదా ఇమెయిల్‌ను అపరిచితులతో పంచుకోవాల్సిన అవసరం లేదు.'
    },
    {
        question: 'నా పోగొట్టుకున్న వస్తువుకు సంభావ్య మ్యాచ్ దొరికితే నేను ఏమి చేయాలి?',
        answer: 'సెర్చ్ రిజల్ట్స్‌లోని "Contact" బటన్‌ను ఉపయోగించి, వస్తువును కనుగొన్న వ్యక్తితో ఒక ప్రైవేట్ చాట్‌ను ప్రారంభించండి. చాట్‌లోని "Verify Ownership" ఫీచర్‌ను ఉపయోగించి, మీరు అందించిన రహస్య గుర్తును గుర్తించమని వారిని అడగడం ద్వారా వారు సరైన యజమానో కాదో నిర్ధారించుకోండి.'
    },
    {
        question: 'ఒక వస్తువును "Resolved" గా ఎలా మార్చాలి?',
        answer: 'హోమ్ పేజీ నుండి "My Found/Lost Items" పేజీకి వెళ్ళండి. అక్కడ మీ పోస్ట్‌ల జాబితా కనిపిస్తుంది. తిరిగి ఇవ్వబడిన లేదా కనుగొనబడిన వస్తువు పక్కన ఉన్న "Mark as Resolved" బటన్‌పై క్లిక్ చేయండి.'
    },
    {
        question: '"Post Strength" మీటర్ అంటే ఏమిటి?',
        answer: '"Post Strength" మీటర్, ఒక వస్తువును పోస్ట్ చేసేటప్పుడు వీలైనంత ఎక్కువ వివరాలను అందించమని మిమ్మల్ని ప్రోత్సహిస్తుంది. అధిక శాతం అంటే మీరు ఎక్కువ సమాచారం అందించారని అర్థం, ఇది మా ఆటోమేటిక్ మ్యాచింగ్ అల్గారిథమ్ మీకు ఒక మ్యాచ్‌ను కనుగొనే అవకాశాలను పెంచుతుంది.'
    }
];

function FAQPage() {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>తరచుగా అడిగే ప్రశ్నలు (FAQ)</Typography>
      <Box mt={3}>
        {faqs.map((faq, index) => (
            <Accordion key={index} defaultExpanded={index === 0}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                >
                    <Typography fontWeight="bold">{faq.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>{faq.answer}</Typography>
                </AccordionDetails>
            </Accordion>
        ))}
      </Box>
    </Paper>
  );
}

export default FAQPage;
